import styled from '@emotion/styled'
import { Select, Pagination as Pager } from 'mailup-web-components'
import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useRecoilCallback, useSetRecoilState } from 'recoil'
import {
  getCampaignListCallback,
  getQueuedEmailRecipientsCallback
} from '../recoil/callbacks/callbacks'
import { manageRecipientsState } from '../recoil/state/manageRecipients'
import { resultsState, searchState } from '../recoil/state/page'

const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StyledSelect = styled(Select)`
  width: 150px;
  font-size: 13px !important;
`
const StyledPager = styled(Pager)`
  &.c-pagination--no-pagi {
    font-size: 13px !important;
  }
`

const Pagination = () => {
  const intl = useIntl()

  const { pageNumber, pageSize, totalItems } = useRecoilValue(
    manageRecipientsState
  )
  const setManageRecipientsState = useSetRecoilState(manageRecipientsState)

  const getQueuedEmailRecipients = useRecoilCallback(
    getQueuedEmailRecipientsCallback,
    []
  )

  const { current: handleChangePageNumber } = useRef(pageNumber => {
    setManageRecipientsState(prev => ({
      ...prev,
      pageNumber: pageNumber
    }))
    getQueuedEmailRecipients()
  })
  const { current: handleChangePageSize } = useRef(pageSize => {
    setManageRecipientsState(prev => ({
      ...prev,
      pageSize,
      pageNumber: 1
    }))
    getQueuedEmailRecipients()
  })

  return (
    <StyledContainer>
      <div>
        {' '}
        <StyledPager
          page={pageNumber}
          pageSize={pageSize}
          totalCount={totalItems}
          onChange={handleChangePageNumber}
          data-mu-test='pager'
          strings={{ of: intl.formatMessage({ id: 'Load.Pager.Of' }) }}
          formatValues={intl.formatNumber}
        />
      </div>
      {totalItems > 5 && (
        <div>
          <StyledSelect
            name='pagesize'
            searchable={false}
            value={pageSize}
            options={[5, 10, 20, 50].map(c => ({
              value: c,
              label: `${c} ${intl.formatMessage({ id: 'Load.Pager.Items' })}`
            }))}
            onChange={handleChangePageSize}
            data-mu-test='select-pagesize'
          />
        </div>
      )}
    </StyledContainer>
  )
}

export default Pagination
